import { ApiProperty } from "@nestjs/swagger";

export class BlanchingCookingDTO{
    @ApiProperty()
    cookingId: number;
    @ApiProperty()
    logId: number;
    @ApiProperty()
    time: Date;
    @ApiProperty()
    blanchingCooking: string;
    @ApiProperty()
    temp1: number;
    @ApiProperty()
    temp2: number;
    @ApiProperty()
    temp3: number;
    @ApiProperty()
    cookingTime: Date;
    @ApiProperty()
    productCoreTemp: number;
    @ApiProperty()
    productTempAfterChilling: number;
    @ApiProperty()
    chillWaterTemp : number;
    @ApiProperty()
    steamPressure : string;
    @ApiProperty()
    chillerTime: Date;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    correctiveAction : string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
}